import { HeaderLogo, HeaderMenu } from '../../components';
import { HeaderDiv } from '../styled/Flex';

const HeaderBar = () => (
  <HeaderDiv>
    <HeaderLogo />
    <HeaderMenu />
  </HeaderDiv>
);

export default HeaderBar;
